var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParametre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.976,
    height: 22.976,
    viewBox: "0 0 22.976 22.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_63",
    "data-name": "Groupe 63",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M14.534,7.531a2.009,2.009,0,0,1,3.9,0,2.014,2.014,0,0,0,3,1.247,2,2,0,0,1,2.756,2.756,2.014,2.014,0,0,0,1.247,3,2.009,2.009,0,0,1,0,3.9,2.014,2.014,0,0,0-1.247,3,2,2,0,0,1-2.756,2.756,2.014,2.014,0,0,0-3,1.247,2.009,2.009,0,0,1-3.9,0,2.014,2.014,0,0,0-3-1.247,2,2,0,0,1-2.756-2.756,2.014,2.014,0,0,0-1.247-3,2.009,2.009,0,0,1,0-3.9,2.014,2.014,0,0,0,1.247-3,2,2,0,0,1,2.756-2.756A2.014,2.014,0,0,0,14.534,7.531Z",
    transform: "translate(-5.998 -5.998)",
    fill: "none",
    stroke: "#53565a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M26.389,22.194A4.194,4.194,0,1,1,22.194,18,4.2,4.2,0,0,1,26.389,22.194Z",
    transform: "translate(-11.707 -11.707)",
    fill: "none",
    stroke: "#53565a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParametre);
export default __webpack_public_path__ + "static/media/parametre.1f498f8ab95dc49c0eaad60befb045bc.svg";
export { ForwardRef as ReactComponent };